import React, { useEffect, useState } from 'react';
import './OfflineUI.css';

const OfflineUI = ({ isOnline }) => {
    const [wasOffline, setWasOffline] = useState(false);
    const [showBackOnline, setShowBackOnline] = useState(false);

    useEffect(() => {
        if (!isOnline) {
            setWasOffline(true);
            setShowBackOnline(false);
        } else if (isOnline && wasOffline) {
            setShowBackOnline(true);
            const timer = setTimeout(() => {
                setShowBackOnline(false);
                setWasOffline(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [isOnline, wasOffline]);

    const isVisible = !isOnline || showBackOnline;

    useEffect(() => {
        document.body.classList.toggle('offline-ui-active', isVisible);
        return () => document.body.classList.remove('offline-ui-active');
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className={`offline-ui-container ${isOnline ? 'online' : 'offline'}`}>
            <span className="offline-ui-text">
                {isOnline ? 'Back online' : 'No internet connection'}
            </span>
        </div>
    );
};

export default OfflineUI;
